import {Box, FormControlLabel, Switch} from '@mui/material';
import {TradeDirection, type Trade} from '@cp/model';

export interface SwitchTradeDirectionProps {
  data: Trade;
  setData: (next: Trade) => void;
  disabled?: boolean;
}

export default function SwitchTradeDirection({data, setData, disabled = false}: SwitchTradeDirectionProps) {
  const checked = data.direction === TradeDirection.SHORT;
  const label = checked ? 'Short' : 'Long';

  return (
    <Box sx={{width: '100%'}}>
      <FormControlLabel
        label="Direction"
        sx={{m: 0, width: '100%', justifyContent: 'space-between'}}
        control={
          <Switch
            checked={checked}
            onChange={(_, nextChecked) =>
              setData({...data, direction: nextChecked ? TradeDirection.SHORT : TradeDirection.LONG})
            }
            disabled={disabled}
          />
        }
      />
      <Box component="span" sx={{display: 'block', textAlign: 'right', typography: 'caption'}}>
        {label}
      </Box>
    </Box>
  );
}
